import { useTransitionConditionAtomValue } from '@/features/analyze/atoms/transitionCondition';
import { useArticleSearchCondition } from '@/features/analyze/hooks/useArticleSearchCondition';
import { graphql, useQuery, VariablesOf } from '@/lib/graphql';

const GET_TRANSITION_DATA_QUERY = graphql(`
  query getTransitionData(
    $condition: ArticleSearchConditionInput!
    $aggregationInterval: TransitionAggregationInterval!
  ) {
    transitionData(
      condition: $condition
      aggregationInterval: $aggregationInterval
    ) {
      values
      xLabels
      yLabels
    }
  }
`);

type TransitionDataVariables = VariablesOf<typeof GET_TRANSITION_DATA_QUERY>;

export const useAnalyzeTransition = () => {
  const condition = useArticleSearchCondition();
  const transitionCondition = useTransitionConditionAtomValue();

  const { data, loading, error } = useQuery(GET_TRANSITION_DATA_QUERY, {
    variables: {
      condition,
      aggregationInterval: transitionCondition.rangeGap,
    } satisfies TransitionDataVariables,
    errorPolicy: 'all',
  });

  // エラーハンドリング
  if (error) {
    console.error('GraphQL Error in useAnalyzeTransition:', error);
  }

  return {
    transitionData: data?.transitionData,
    isLoading: loading,
    error,
  };
};
